import moment from 'moment';
import { useEffect, useState } from 'react';
import useVacationRequestActions from '../../hooks/APIHooks/users/useVacationRequestActions';
import DashboardSectionLayout from '../../layouts/DashboardSectionLayout';
import { CalendarEvent } from '../../types/common';
import AcademiaCalendar from '../CommonComps/Calendars/AcademiaCalendar';
import IndicationBadge from '../CommonComps/IndicationBadge';

const VacationHistory = () => {
  // integration of react hooks here
  const [calendarData, setCalendarData] = useState<Array<CalendarEvent>>([]);

  // integration of custom API hooks here
  const { getVacationRequestListHandler } = useVacationRequestActions(
    'vacationRequestList'
  );

  useEffect(() => {
    if (getVacationRequestListHandler.data?.data.length) {
      setCalendarData(
        getVacationRequestListHandler.data.data.map((vacation) => ({
          start: moment(`${vacation.start_date}`).toDate(),
          end: moment(`${vacation.end_date}`).toDate(),
          data: {
            title: vacation.description,
            description: vacation.rejected_note || 'N/A',
            status: vacation.is_approved
              ? 'Approved'
              : vacation.is_rejected
              ? 'Rejected'
              : 'Pending',
            isVacation: true,
          },
        }))
      );
    } else {
      setCalendarData([]);
    }
  }, [getVacationRequestListHandler.data]);

  console.log('VACATION HISTORY: ', calendarData);

  // rendering vacation history section component here
  return (
    <DashboardSectionLayout sectionTitle='Vacation History'>
      <AcademiaCalendar
        events={calendarData}
        layoutId='vacation-calendar-underline'
      />

      <div className='mt-2 flex items-center justify-center md:justify-end gap-3'>
        <IndicationBadge indicationText='Approved' colorHex='#00BCEF' />
        <IndicationBadge indicationText='Pending' colorHex='#FF8042' />
        <IndicationBadge indicationText='rejected' colorHex='#E6533C' />
      </div>
    </DashboardSectionLayout>
  );
};

export default VacationHistory;
